import { FormBase } from 'core/components';

export default class UserEditForm extends FormBase {
    constructor(hooks) {
        super(hooks);
    }

    setup() {
        return {
            fields: [
                {
                    name: 'email',
                    label: 'USER.EDIT.EMAIL_LABEL',
                    placeholder: 'USER.EDIT.EMAIL_PLACEHOLDER',
                    rules: 'required|email|string'
                },
                {
                    name: 'firstName',
                    label: 'USER.EDIT.FIRST_NAME_LABEL',                                        
                    placeholder: 'USER.EDIT.FIRST_NAME_PLACEHOLDER',                    
                    rules: 'required|string'                    
                },
                {
                    name: 'lastName',
                    label: 'USER.EDIT.LAST_NAME_LABEL',                                                            
                    placeholder: 'USER.EDIT.LAST_NAME_PLACEHOLDER',                                        
                    rules: 'required|string'                    
                },
                {
                    name: 'displayName',
                    label: 'USER.EDIT.DISPLAY_NAME',
                    placeholder: 'USER.EDIT.DISPLAY_NAME_PLACEHOLDER',
                    rules: 'required'
                },
                {
                    name: 'userName',
                    label: 'USER.CREATE.USERNAME_LABEL',
                    placeholder: 'USER.CREATE.USERNAME_PLACEHOLDER',
                    rules: 'required|string'
                },
                {
                    name: 'roles',
                    label: 'USER.EDIT.ROLES_LABEL',
                    placeholder: 'USER.EDIT.ROLES_PLACEHOLDER',
                    rules: 'required'
                }
            ]
        };
    }
}
